<script>

    import { toast } from 'bulma-toast'
    import { shipmentsSelectedStore } from '../stores'

    import ShipmentsService from '../$services/shipments.service'
    import Spinner from '../$components/spinner.svelte'

    let loading = false
    let globalIndex = 0
    let element;

    downloadGuides()

    async function downloadGuides() {

        loading = true
        await downloadGuide()
        loading = false

    }

    async function downloadGuide(index = 0) {

        globalIndex = index

        if(index >= $shipmentsSelectedStore.length)
            return

        const shipment = $shipmentsSelectedStore[index]

        const blob = await ShipmentsService.getShipmentDocument(shipment._id)

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        const order = shipment.order

        element.download = `${shipment.user.name}_N.${order.number}_${order.storeType}_${shipment.provider}_${shipment.guide}.pdf`
        element.href = window.URL.createObjectURL(blob)
        element.click()
        
        return await downloadGuide(index+1)
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<div class="is-flex is-flex-direction-column is-align-items-center">
    <Spinner {loading} />
    <br>
    {#if globalIndex === $shipmentsSelectedStore.length}
        <div class="title">Proceso finalizado <span class="icon"><i class="fas fa-laugh-wink"></i></span></div>
    {:else}
        <div class="title is-4">Descargando guías</div>
    {/if}
    <div class="subtitle is-5">{globalIndex} de {$shipmentsSelectedStore.length}</div>
</div>